module.exports = __webpack_public_path__ + "img/import-blue.b079db9f.svg";